/**
 * bogo-bundle-sale-mask LP — minimal behavior
 *
 * No carousel is required for the press-logo row or the products grid (both
 * are static CSS grids/flex rows), and the FAQ uses native <details>/<summary>.
 * The only behavior this LP needs is anchor-scroll offset compensation.
 * The offer bar and header match the mockup and stay in normal flow unless
 * the announcement sticky setting is on. Offset is added only for elements
 * whose computed position is sticky.
 */
(() => {
  const initAnchorOffset = (root) => {
    const links = root.querySelectorAll('a[href^="#"]');
    if (!links.length) return;

    const getStickyOffset = () => {
      const announcement = root.querySelector('.bbsm-announcement');
      const header = root.querySelector('.bbsm-header');
      let offset = 0;
      if (announcement && getComputedStyle(announcement).position === 'sticky') {
        offset += announcement.getBoundingClientRect().height;
      }
      if (header && getComputedStyle(header).position === 'sticky') {
        offset += header.getBoundingClientRect().height;
      }
      return offset + 12;
    };

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const hash = link.getAttribute('href');
        if (!hash || hash === '#') return;

        const target = root.querySelector(hash);
        if (!target) return;

        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - getStickyOffset();
        window.scrollTo({ top, behavior: 'smooth' });

        if (history.pushState) {
          history.pushState(null, '', hash);
        }
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('.bbsm-lp').forEach(initAnchorOffset);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
